module.exports = __webpack_public_path__ + "images/snow.e694c33dee62c512b85c5ae5b920c1fa.png";